import { AfpantPantedokumentResponse } from "@/components/AfpantPantedokumentResponse/AfpantPantedokumentResponse";
import { DocumentTitle } from "@/components/DocumentTitle/DocumentTitle";
import { routeLoaderApiClient } from "@/lib/api";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated-user/superuser/afpant/$orgNumber/pantedokumentsvar/$pantedokumentResponseId/",
)({
  loader: async ({ params }) => {
    const { orgNumber, pantedokumentResponseId } = params;

    const res = await routeLoaderApiClient.superuser.afpant[":orgNumber"]["pantedokument-response"][
      ":pantedokumentResponseId"
    ].$get({
      param: {
        orgNumber,
        pantedokumentResponseId,
      },
    });

    if (res.ok === false) {
      throw new Error("Failed to fetch pantedokument response");
    }

    return {
      response: await res.json(),
    };
  },
  head: () => ({
    meta: [{ title: "Pantedokumentsvar | Alice & Bob" }],
  }),
  component: Page,
});

function Page() {
  const { orgNumber } = Route.useParams();
  const { response } = Route.useLoaderData();

  return (
    <>
      <DocumentTitle>Pantedokumentsvar</DocumentTitle>

      <AfpantPantedokumentResponse orgNumber={orgNumber} response={response} />
    </>
  );
}
